import * as React from "react";

import { Period, display12HourValue, setDateByType } from "./time-picker-utils";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export interface PeriodSelectorProps {
  period: Period;
  setPeriod: (m: Period) => void;
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
  onRightFocus?: () => void;
  onLeftFocus?: () => void;
  disabled?: boolean;
}

export const TimePeriodSelect = React.forwardRef<
  HTMLButtonElement,
  PeriodSelectorProps
>(
  (
    { period, setPeriod, date, setDate, onLeftFocus, disabled, onRightFocus },
    ref,
  ) => {
    const [localPeriod, setLocalPeriod] = React.useState<Period>(period);

    React.useEffect(() => {
      setLocalPeriod(period);
    }, [period]);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>): void => {
      if (e.key === "ArrowRight") {
        onRightFocus?.();
      }
      if (e.key === "ArrowLeft") {
        onLeftFocus?.();
      }
    };

    const handleValueChange = (value: Period): void => {
      setPeriod(value);

      /**
       * trigger an update whenever the user switches between AM and PM;
       * otherwise user must manually change the hour each time
       */
      if (date) {
        const tempDate = new Date(date);
        const hours = display12HourValue(date.getHours());
        setDate(
          setDateByType({
            date: tempDate,
            value: hours.toString(),
            type: "12hours",
            period: period === "AM" ? "PM" : "AM",
          }),
        );
      }
    };

    return (
      <div className='flex h-10 items-center'>
        <Select
          value={localPeriod}
          onValueChange={(value: Period) => handleValueChange(value)}
          disabled={disabled}
        >
          <SelectTrigger
            ref={ref}
            className='w-[50px]  focus:bg-accent focus:text-accent-foreground border-0'
            onKeyDown={handleKeyDown}
            isArrow={false}
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value='AM'>AM</SelectItem>
            <SelectItem value='PM'>PM</SelectItem>
          </SelectContent>
        </Select>
      </div>
    );
  },
);

TimePeriodSelect.displayName = "TimePeriodSelect";
